// Styles for Tag (single pill) derived from PillGroup

$transition-duration: .1s;

.tag-style {
  position: relative;
  --tag-icon-size: 1em;
  --tag-icon-gap: 4px;
  --tag-icon-reveal-delay: 600ms;
  --tag-label-right-padding: calc(var(--tag-icon-size) + var(--tag-icon-gap));
  transition:
    background-color $transition-duration ease-in-out,
    border-color $transition-duration ease-in-out,
    color $transition-duration ease-in-out;
  cursor: pointer;

  //Hover state
  &.pill--clickable:hover {
    border: 1px solid var(--color-border-primary-hover);
    background:  var(--color-bg-secondary-hover);
    color: var(--color-text-primary);;
  }

  // Active (pressed) state
  &.pill--clickable:active {
    border: 1px solid #61646B;
    background: #94979E;
    color: var(--color-text-primary);;
  }

  // Selected state
  &.selected {
    border: 1px solid var(--color-border-tertiary);
    background:  var(--color-fill-tertiary);
    color: var(--color-text-on-accent);

    &.pill--clickable:hover {
      border: 1px solid var(--color-border-tertiary);
      background:  var(--color-fill-tertiary-hover);
    }

    &.pill--clickable:active {
      border: 1px solid var(--color-border-tertiary-pressed);
      background:  var(--color-fill-tertiary-focus);
      color: var(--color-text-tertiary);
    }
  }
}


// Truncated/ellipsis label handling
.tag__label {
  flex: 1 1 auto;
  min-width: 0; // allow flex child to shrink for ellipsis
  white-space: nowrap; // keep the text on one line
  overflow: hidden;
  text-overflow: ellipsis;
  transition: max-width 120ms ease-in-out;
  max-width: 100%;
}

// Icon base (non-interactive by default)
.tag__icon {
  position: absolute;
  right: var(--tag-icon-gap);
  top: 50%;
  transform: translateY(-50%);
  font-size: 16px !important;
  line-height: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 120ms ease-in-out, visibility 0s linear 120ms;
  pointer-events: none; // non-interactive when hidden
  width: var(--tag-icon-size);
  height: var(--tag-icon-size);
  visibility: hidden;


  &.material-icons-outlined {
    font-family: 'Material Icons Outlined';

    &:hover,
    &:focus {
      font-family: 'Material Icons';
    }
  }
  &--destructive {
      color: var(--color-icon-error);
  }
}

// Interactive icon variant
.tag__icon--clickable {
  cursor: pointer;
}

.tag-style:has(.tag__icon):hover .tag__label,
.tag-style:has(.tag__icon):focus-within .tag__label {
  max-width: calc(100% - var(--tag-label-right-padding));
  transition-delay: var(--tag-icon-reveal-delay);
}


/* Reveal icon and make room only on hover/focus */
.tag-style:hover .tag__icon,
.tag-style:focus-within .tag__icon,
.tag__icon:focus {
  visibility: visible;
  opacity: 1;
  transition-delay: var(--tag-icon-reveal-delay);
}

/* Only enable pointer events for clickable icons when visible */
.tag-style:hover .tag__icon--clickable,
.tag-style:focus-within .tag__icon--clickable,
.tag__icon--clickable:focus {
  pointer-events: auto;
}

.tag__input {
  border: none !important;       /* remove the thin border */
  outline: none;      /* remove the focus outline */
  background: transparent; /* optional, blends with parent */
  font: inherit;      /* inherit font styling from parent */
  color: inherit;     /* keeps consistent text color */
  &:focus {
    border-bottom: 1px solid #888;
  }
}
